import React,{ useState} from 'react';
import './Topbar.css';
import down from '../../assets/down.svg';
import filter from  '../../assets/filter.svg';
function ThreeTop({toggleFilter}) {

    return (

        <div className="top-bar-create">
            {/* <button className="button" onClick={toggleFilter}>
                <span>Filter</span>
                <img src={filter} alt="Filter Icon" />
            </button> */}

            {/* <div className="sort-container">
                <span>Sort by:</span>
                <div className="dropdown">
                    <span>Latest</span>
                    <img src={down} alt="Dropdown Icon" />
                </div>
            </div> */}

            <div className="results-count"></div>
        </div>
    );
}
export default ThreeTop;
